import { defaultThemes } from "react-data-table-component";
export const BASE_URL_PRODUCCION = 'https://arcoprime-contrata-api-dev.i1.cl/api';
export const BASE_URL_INTRANET = 'https://qa.miviaje.cl/';

export const PLAZOS = [
  { label: "Plazo Fijo 30 Días", value: "1" },
  { label: "Plazo Fijo 60 Días", value: "2" },
  { label: "Plazo Fijo 90 Días", value: "3" },
  { label: "Indefinido", value: "4" }
]

export const DOCUMENTOS = [
  { 'id_tipo': 1, 'documento': "curriculum", "nombre_mensaje": 'Currículum vitae' },
  { 'id_tipo': 2, 'documento': "cedula", "nombre_mensaje": 'Cédula identidad' },
  { 'id_tipo': 3, 'documento': "antecedentes", "nombre_mensaje": 'Certificado antecedentes' },
  { 'id_tipo': 4, 'documento': "residencia", "nombre_mensaje": 'Certificado residencia' },
  { 'id_tipo': 5, 'documento': "afp", "nombre_mensaje": 'Certificado AFP' },
  { 'id_tipo': 6, 'documento': "salud", "nombre_mensaje": 'Certificado salud' },
  { 'id_tipo': 7, 'documento': "visa", "nombre_mensaje": 'Certificado visa' },
  { 'id_tipo': 8, 'documento': "discapacidad", "nombre_mensaje": 'Certificado discapacidad' },
  { 'id_tipo': 9, 'documento': "covid", "nombre_mensaje": 'Certificado seguro covid' },
  { 'id_tipo': 10, 'documento': "jubilacion", "nombre_mensaje": 'Certificado jubilacion' }
];

export const ESTADO_SOLICITUD = {
  1: "Inicia proceso postulante nuevo",
  2: "Evaluacion Proceso y Remuneraciones",
  3: "Evaluacion Proceso y Remuneraciones",
  4: "Evaluacion Jefe De Zona",
  5: "Solicitud Reingreso Aprobada",
  6: "Evaluacion Jefe de Zona",
  7: "Corrección solicitada por Jefe de Zona",
  8: "Sin respuesta por el jefe inmediato, sistema escala a proceso y remuneraciones",
  9: "Evaluacion Proceso y Remuneraciones",
  10: "Corrección solicitada por Procesos y Remuneraciones",
  11: "Sin correccion del solicitante por rechazo de Proceso y remuneraciones, sistema declina solicitud",
  12: "Sin respuesta por proceso y remuneraciones , sistema escala a jefe inmediato",
  13: "Por enviar a SAP",
  14: "Reserva contratacion",
  15: "Enviado a SAP",
  16: "Solicitud declinada",
  17: "En espera finalización formulario",
  18: "Solicitud pausada por falta de dato"
}


export const DOMINIOS_VALIDOS = [
  "arcoprime.cl",
  "ARCOPRIME.CL",
  "escopec.cl",
  "ESCOPEC.CL",
  "arcoalimentos.cl",
  "ARCOALIMENTOS.CL",
];

export const TIPO_SOLICITUD = {
  1: "cambio de cargo",
  2: "cambio de unidad",
  3: "cambio de instalación",
  4: "renovación de plazo",
  5: "solicitud de desvinculación",
}

export const BACKDROP = '#395c9d5c left top no-repeat';

export const CUSTOM_CLASS = {
  container: 'containerMensajeSimple',
  title: 'titleMensajeSimple',
  text: 'txtLabellInput',
  popup: `popUpSweetCancelarEnviar`,
  confirmButton: 'btnCopec me-4 mt-1',
  cancelButton: 'btnAtras',
}

export const binario = '';

export const customStyles = {
  tableBody: {
    style: {
      borderLeftStyle: 'solid',
      borderLeftWidth: '1px',
      borderLeftColor: defaultThemes.default.divider.default,
      width: 'auto',
    },
  },
  header: {
    style: {
      minHeight: '40px',
      display: 'flex',
      justifyContent: 'between',
      width: "auto",
    },
  },
  headRow: {
    style: {
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      // width: 'auto',
      borderTopColor: defaultThemes.default.divider.default,

    },
  },
  headCells: {
    style: {
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: defaultThemes.default.divider.default,

      },
      marginLeft: '2px',
      marginRight: '2px',
      fontSize: '13px',
      display: 'flex',
      // justifyContent: 'center'
    },
  },
  cells: {
    style: {
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: defaultThemes.default.divider.default,
      },
      marginLeft: '2px',
      marginRight: '2px',
      fontSize: '14px!important',
      width: "auto",
      display: 'flex',
    },
  },
  responsiveWrapper: {
    style: {
      border: `1px solid ${defaultThemes.default.divider.default}`,
    }
  },
};

export const paginationComponentOptions = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};


export const objStyleCol = {
  display: 'flex',
  justifyContent: 'center',
  // textAlign:"center"
}

export const TIPO_CONTRATO = [
  { value: "01", label: "Cambiar estatus a indefinido" },
  { value: "02", label: "Renovar plazo fijo" },
];

export const TIPO_DE_SOLICITUD = [
  { value: "1", label: "Cambio de cargo" },
  { value: "2", label: "Cambio de unidad" },
  { value: "3", label: "Cambio de instalación" },
  { value: "4", label: "Renovación de plazo" },
  { value: "5", label: "Desvinculación de colaborador" },
];

export const txtMensajeDatosIngresados = 'Los datos Laborales no pueden ser editados dado que ya existe una integración en curso del cargo seleccionado con SAP. Si requiere editar los cargos debe comenzar un nuevo proceso de ingreso de personal';
export const txtUnProblema = 'Ha ocurrido un problema!';
export const errDigitosAnio = "Indique el año con 4 dígitos";
export const ACEPTA_CAMBIO_CARGO = "¿Está seguro de aprobar esta solicitud?";
export const RECHAZA_CAMBIO_CARGO = "¿Está seguro de rechazar esta solicitud?";

export const PUESTOS = {
  '2': "JEFE DE ZONA",
  '3': "REMUNERACIONES",
  '4': "ADMINISTRADOR",
  '5': "SISTEMA",
  '6': "SUPERVISOR FIRMAS",
  '7': "REVISOR FIRMAS"
};

export const EXISTE_MENU = "1";